// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6decd66b","703":"ab0d6a7b"}[chunkId] + ".chunk.js";
};